import { Link } from "react-router-dom";

const Brand = ({ height, white }) => {
  return (
    <Link to={"/"}>
      {white ? (
        <img
          src={require("../../assets/screen_logo.png")}
          alt=""
          className={`${height || "h-8"}`}
        />
      ) : (
        <img
          src={require("../../assets/screen_logo.png")}
          alt=""
          className={`${height || "h-8"}`}
        />
      )}
    </Link>
  );
};

export default Brand;
